export default __webpack_public_path__ + "e63319bfaec5998a6d631b4ac56bd2b4.png";